<template>
  <div v-if="!isLoading" class="container">
    <div class="mt-4 mb-2 d-flex justify-content-between align-items-center">
      <back-arrow
        :bilan-type="this.bilanType"
        :operation-type="this.operationType"
        :title="operation.name"
        routeBack="OperationIndex"/>
      <div>

        <!--        BOUTON BILAN-->
        <button v-if="operation.bilanId && this.hasExeBilan === false"
                :class="`${this.bilanType.toLowerCase()}-btn-inverted`"
                class="edit mr-1 btn-switch"
                @click="clickOnChangeBilanType()">
          {{ this.bilanType === 'AVP' ? $t('operation.bilan.create.EXE') : $t('operation.bilan.go.AVP') }}
        </button>
        <button v-if="operation.bilanId && this.hasExeBilan === true"
                :class="`${this.bilanType.toLowerCase()}-btn-inverted`"
                class="edit mr-1 btn-switch"
                @click="clickOnChangeBilanType()">
          {{ this.bilanType === 'AVP' ? $t('operation.bilan.go.EXE') : $t('operation.bilan.go.AVP') }}
        </button>
        <button class="show-action-btn edit mr-1" @click="clickOnEditBtn()">
          <pencil-icon size="18"/>
        </button>
        <button v-if="allowDelete" class="show-action-btn delete" @click="clickOnDeleteBtn()">
          <trash-icon size="18"/>
        </button>
      </div>
    </div>

    <template v-for="alert in taskAlerts">
      <b-alert :variant="alert.style" class="my-1" dismissible show @dismissed="modifyAlertDate(alert.tasks)">
        <b-link @click="showTasks"> {{ alert.element + ' ' + $t(alert.content) + ' ' }}</b-link>
      </b-alert>
    </template>

    <div class="row my-3">
      <div class="col-md-4">
        <b-card class="info-card">
          <div class="row d-flex flex-row align-items-center fullSize">
            <div v-if="operation.picture" class="col-md-5 fullSize">
              <img :src="getFileUrl(operation.picture.fileUrl)" alt="" class="fullSize imgcover"/>
            </div>
            <div v-else class="col-md-5">
              <img :src="require(`@/assets/images/APRILYOS/emptyState.png`)" alt="No picture" class="no-result-img"
                   style="max-width: 100%; max-height: 120px;">
            </div>
            <div class="col-md-7 pl-0">
              <div v-if="operation.address && operation.postalCode && operation.city" class="my-3">
                {{ operation.address + ", " + operation.postalCode + " " + operation.city }}
              </div>
              <div v-else class="my-3">
                {{ $t('operation.address.to.be.define') }}
              </div>

              <div v-if="operation.nbLots > 1" class="bold-text main-color-text level-one-title">
                {{
                  operation.nbLots + ' ' + $t('OperationLots') + ' - ' + Intl.NumberFormat().format(operation.prix) + " €"
                }}
              </div>
              <div v-else class="bold-text main-color-text level-one-title">
                {{
                  operation.nbLots + ' ' + $t('OperationLot') + ' - ' + Intl.NumberFormat().format(operation.prix) + ' €'
                }}
              </div>
            </div>
          </div>
        </b-card>
      </div>

      <div class="col-md-4 general-card h-auto">
        <b-card >
          <div class="bold-text main-color-text">
            <div class="d-flex justify-content-between align-items-center">
              <div class="">
                {{ $t('operation.General') }}
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-6 pr-1">
                <b-button class="col-md-12 mini w-100" variant="primary" @click="showDocuments()">
                  {{ $t("operation.general.documents") }}
                </b-button>
              </div>
              <div class="col-md-6 pl-1">
                <b-button class="col-md-12 mini w-100 d-flex justify-content-center" variant="primary"
                          @click="showTasks()">
                  <div :class="{'ml-auto':taskAlerts.length !== 0}" class="d-flex align-self-center">
                    {{ $t("operation.general.taches") }}
                  </div>
                  <div v-if="taskAlerts.length !== 0" class="ml-auto">
                    <div class="pastille-fail">
                      {{ taskAlerts.length }}
                    </div>
                  </div>
                </b-button>
              </div>
              <div class="col-md-6 mt-2 pr-1">
                <b-button class="col-md-12 mini w-100" variant="primary" @click="showPlanning()">
                  {{ $t("operation.general.planning") }}
                </b-button>
              </div>
              <div class="col-md-6 mt-2 pl-1 w-100">
                <b-button class="col-md-12 mini" variant="primary"
                          @click="showAnalyse()">
                  {{ $t("operation.general.analyse") }}
                </b-button>
              </div>
            </div>
          </div>
        </b-card>
      </div>

        <div v-if="isEstateAgent || isCollaboratorPlus" class="col-md-4 h-auto">
        <finance-card-pagination
          :operation-lots="operationLots"
          :operation-type="operationType"
          :bilan-type="bilanType"
          :operation-bilan-id="operationBilanId"
          :operation-id="operationId"
        ></finance-card-pagination>
      </div>

    </div>

    <b-card class="my-3">
      <div class="mb-4">
        <div class="col">
          <b-nav class="multi-tabs-field-navbar">
            <b-nav-item v-for="(tab, index) in tabs" :key="index + '-nav-key'"
                        :class="{ 'link-active': currentSection === index }"
                        class="multi-tabs-field-navbar-item"
                        @click.prevent="currentSection = index">
              <div v-if="operationBilanId == null && tab === $t('operation.show.tab.bilan')">
                {{ $t(tab) }}
                <b-icon-dot class="main-red-color" scale="3"></b-icon-dot>
              </div>
              <div v-else-if="taskAlerts.length>0 && tab===$t('operation.show.tab.tasks')">
                {{ $t(tab) }}
                <b-icon-dot class="main-red-color" scale="3"></b-icon-dot>
              </div>
              <div v-else>
                {{ $t(tab) }}
              </div>
            </b-nav-item>
          </b-nav>
        </div>

        <b-container fluid>
          <b-row>
            <b-col v-for="(tab, index) in tabs" v-if="currentSection === index" :key="index + '-content-key'">
              <template v-if="currentSection === 0">
                <operation-show-informations
                  :current-section-id="0"
                  :operation-id="operationId">
                </operation-show-informations>
              </template>

              <template v-if="tabs.length > 2 && currentSection === 1">
                <operation-show-charges
                  :operation-bilan-id="operationBilanId"
                  :operation-id="operationId"
                  :simulation-id="operation.simulationId"/>
              </template>
              <template v-else-if="tabs.length <=2 && currentSection === 1">
                <operation-show-bilan
                  :operation-bilan-id="operationBilanId"
                  :operation-id="operationId">
                </operation-show-bilan>
              </template>

              <template v-if="currentSection === 2">
                <operation-show-construction
                  :operation-name="operation.name"
                  :current-mode="currentMode"
                  :operation-bilan-id="operationBilanId"
                  :operation-id="operationId"
                  :simulation-id="operation.simulationId"/>
              </template>

              <template v-if="currentSection === 3">
                <operation-show-honoraires
                  :operation-bilan-id="operationBilanId"
                  :operation-id="operationId"
                  :simulation-id="operation.simulationId"/>
              </template>

              <template v-if="currentSection === 4">
                <operation-show-insurances
                  :acte-achat="acteAchat"
                  :operation-bilan-id="operationBilanId"
                  :operation-id="operationId"
                  :simulation-id="operation.simulationId"/>
              </template>

              <template v-if="currentSection === 5">
                <operation-show-frais-financiers
                  :acte-achat="acteAchat"
                  :operation-bilan-id="operationBilanId"
                  :operation-id="operationId"
                  :simulation-id="operation.simulationId"/>
              </template>

              <template v-if="currentSection === 6">
                <operation-show-bilan
                  :operation-bilan-id="operationBilanId"
                  :operation-id="operationId">
                </operation-show-bilan>
              </template>
            </b-col>

          </b-row>
        </b-container>
      </div>
    </b-card>

    <Item-delete-modal
      :beginsWithVoyel="true"
      :isFeminine="true"
      :selectedItem="selectedOperation"
      controllerName="operation"
      itemSingularName="operation"
      itemSingularNameUpp="Operation"
      @didDeleteItem="didDeleteOperation()">
    </Item-delete-modal>

    <change-bilan-type-operation-modal :alreadyHasExe="this.hasExeBilan" :bilan-type-name="this.bilanType"
                                       :operation-id="Number(this.operationId)"
                                       @didChangeBilanType='didChangeBilanType'>

    </change-bilan-type-operation-modal>

    <calendrier-operation-modal id="calendarOperationModal" :calendrier-url="calendarUrl"></calendrier-operation-modal>

  </div>
</template>

<script>

import BackArrow from "../../components/b122/BackArrow";
import ItemDeleteModal from "../../components/b122/ItemDeleteModal";
import OperationShowInformations from "./OperationShowTabs/OperationShowInformations";
import OperationShowBilan from "./OperationShowTabs/OperationShowBilan";
import OperationShowDocuments from "./OperationShowTabs/OperationShowDocuments";
import OperationShowTasks from "./OperationShowTabs/OperationShowTasks";
import OperationShowDossier from "./OperationShowTabs/OperationShowDossier";
import OperationShowPlanning from "./OperationShowTabs/OperationShowPlanning";
import OperationShowAnalyse from "./OperationShowTabs/OperationShowAnalyse";
import OperationShowEmprunt from "./OperationShowTabs/OperationShowEmprunt";
import OperationShowInvestor from "./OperationShowTabs/OperationShowInvestor";
import api from "../../services/api";
import OperationChargeComponent from "../operationBilan/components/OperationChargeComponent.vue";
import OperationShowCharges from "./OperationShowTabs/OperationShowCharges.vue";
import OperationShowConstruction from "./OperationShowTabs/OperationShowConstruction.vue";
import OperationShowHonoraires from "./OperationShowTabs/OperationShowHonoraires.vue";
import OperationShowInsurances from "./OperationShowTabs/OperationShowInsurances.vue";
import OperationShowFraisFinanciers from "./OperationShowTabs/OperationShowFraisFinanciers.vue";
import ChangeBilanTypeOperationModal from "../operationBilan/components/ChangeBilanTypeOperationModal";
import FinanceCardPagination from "./components/FinanceCardPagination";
import CalendrierOperationModal from "../operationBilan/components/CalendrierOperationModal";

export default {
  name: "OperationIndex",

  components: {
    OperationShowFraisFinanciers,
    OperationShowInsurances,
    OperationShowHonoraires,
    OperationShowConstruction,
    OperationShowCharges,
    OperationChargeComponent,
    BackArrow,
    ItemDeleteModal,
    OperationShowInformations,
    OperationShowBilan,
    OperationShowDocuments,
    OperationShowTasks,
    OperationShowDossier,
    OperationShowPlanning,
    OperationShowAnalyse,
    OperationShowEmprunt,
    OperationShowInvestor,
    ChangeBilanTypeOperationModal,
    FinanceCardPagination,
    CalendrierOperationModal
  },

  data() {
    return {
      isLoading: false,
      tabs: [],
      bilanType: "AVP",
      hasExeBilan: false,
      acteAchat: null,
      currentSection: 0,
      currentMode: 'budget',
      operationId: this.$route.params.operationId,
      operationBilanId: null,
      isEstateAgent: this.$store.getters.isEstateAgent,
      isCollaboratorPlus: this.$store.getters.isCollaboratorPlus,
      isCollaborator: this.$store.getters.isCollaborator,
      selectedOperation: null,
      operationType: null,
      operation: {
        name: null,
        address: null,
        postalCode: null,
        city: null,
        picture: null,
        estateAgent: null,
        simulation: null,
        prix: 0,
        nbLots: 0,
        dossierOperationCreationDone: false,
        bilanId: null,
        bilanType: null,
      },
      allowDelete: null,
      taskAlerts: [],
      operationLots: [],
      calendarUrl: null,
    }
  },


  async created() {
    if (this.$route.params.currentSection) {
      this.currentSection = Number(this.$route.params.currentSection);
    } else {
      this.currentSection = 0
    }
    if (this.$route.params.currentMode) {
      this.currentMode = this.$route.params.currentMode
    } else {
      this.currentMode = 'budget'
    }
    this.operationId = Number(this.$route.params.operationId);
  },

  async mounted() {
    await this.fetchData()
    if (this.operationBilanId != null) {
      this.tabs = [
        this.$i18n.t('operation.show.tab.lots'),
        this.$i18n.t('operation.show.tab.charges'),
        this.$i18n.t('operation.show.tab.construction'),
        this.$i18n.t('operation.show.tab.honoraire'),
        this.$i18n.t('operation.show.tab.assurances'),
        this.$i18n.t('operation.show.tab.frais'),
        (this.bilanType && this.bilanType === 'EXE') ? this.$t('operation.show.tab.bilan.exe') : this.$t('operation.show.tab.bilan'),
      ]
    } else {
      this.tabs = [
        this.$i18n.t('operation.show.tab.lots'),
        this.$i18n.t('operation.show.tab.bilan')
      ]
    }

  },

  methods: {


    getFileUrl() {
      return process.env.SERVER_URL + this.operation.picture.fileUrl
    },

    async fetchData() {
      this.isLoading = true
      await this.fetchOperation()
      await this.fetchAuthorization()
      await this.fetchLots()
      await this.fetchOperationBilanId()
      await this.fetchTaskAlerts()
      this.isLoading = false
    },

    async fetchOperation() {
      await api
        .get(`/operation/${this.operationId}`)
        .then(response => {
          this.selectedOperation = response.data
          this.operation.name = response.data.name
          this.operation.address = response.data.address
          this.operation.postalCode = response.data.postalCode
          this.operation.city = response.data.city
          this.operation.picture = response.data.picture
          this.operation.estateAgent = response.data.estateAgent
          this.operation.simulation = response.data.simulation
          this.operation.dossierOperationCreationDone = response.data.dossierOperationCreationDone
          this.operation.bilanId = response.data.bilanId
          this.bilanType = response.data.bilanType
          this.operationDate = new Date(response.data.estimatedStartDate)
          this.acteAchat = response.data.acteAchat
          this.operationType = response.data.operationType
          this.calendarUrl = response.data.calendarUrl

          for (let bilan of response.data.operationBilans) {
            if (bilan.bilanType === 'EXE') {
              this.hasExeBilan = true;
            }
          }
        })
    },



    async fetchAuthorization() {
      await api
        .get(`/operation/getAuthorization/${this.operationId}`)
        .then(response => {
          this.allowDelete = response.data.allowDelete
        })
    },

    async fetchLots() {
      await api
        .get(`/operationLot/getAllForOperation/${this.operationId}`)
        .then(response => {
          this.operation.prix = 0
          this.operation.nbLots = 0
          this.operationLots = response.data
          response.data.forEach(lot => {
            this.operation.prix += lot.prixVenteTTC
            this.operation.nbLots++
          })
        })
    },

    async switchOperationLotForVenteLotCreateBilanEXE() {
      await api
        .post(`/venteLot/switchOperationLotForVenteLotCreateBilanEXE/${this.operationId}`)
        .then(response => {

        })
    },

    async fetchOperationBilanId() {
      await api
        .get(`/operation/getOperationBilanId/${this.operationId}`)
        .then(response => {
          this.operationBilanId = response.data.id
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 0,
                message: error.response.data.message
              }
            })
          }
        })
    },

    async fetchTaskAlerts() {
      await api
        .get(`/operationTask/getAlertsForOperation/${this.operationId}`)
        .then(response => {
          this.taskAlerts = response.data
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 0,
                message: error.response.data.message
              }
            })
          }
        })
    },

    async modifyAlertDate(tasksId) {
      let today = new Date()
      today.setHours(0, 0, 0)
      let tomorrow = today.getTime() + (24 + 9) * 60 * 60 * 1000
      for (const id of tasksId) {
        let data = new FormData()
        data.append('alertDate', tomorrow.toString())
        let url = '/operationTask/updateAlertDate/' + id

        await api({
          method: 'POST',
          url: url,
          data: data
        })
          .then(() => {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 3
              }
            })
          })
          .catch((error) => {
            if (error.response.status === 401 || error.response.status === 404) {
              this.$router.push({
                name: 'OperationShow',
                params: {
                  operationId: this.operationId,
                  currentSection: 3,
                  message: error.response.data.message
                }
              })
            }
          })
      }
    },

    showDocuments() {
      this.$router.push({
        name: 'OperationShowDocuments',
        params: {
          operationId: this.operationId
        }
      })
    },

    showTasks() {
      this.$router.push({
        name: 'OperationShowTasks',
        params: {
          operationId: this.operationId
        }
      })
    },

    showAnalyse() {
      let simulationId
      if (this.operation.simulation) {
        simulationId = this.operation.simulation.id
      }
      this.$router.push({
        name: 'OperationShowAnalyse',
        params: {
          operationId: this.operationId,
          simulationId: simulationId
        }
      })
    },

    showCalendar() {
      this.$bvModal.show('calendarOperationModal')
    },

    showPlanning() {
      this.$router.push({
        name: 'OperationShowPlanning',
        params: {
          operationId: this.operationId,
          isGlobal: false
        }
      })
    },

    showDossier() {
      this.$router.push({
        name: 'OperationShowDossier',
        params: {
          operationId: this.operationId,
          dossierOperationCreationDone: this.operation.dossierOperationCreationDone
        }
      })
    },

    showEmprunt() {
      this.$router.push({
        name: 'OperationShowEmprunt',
        params: {
          operationId: this.operationId,
          operationDate: this.operationDate,
        }
      })
    },

    showInvestor() {
      this.$router.push({
        name: 'OperationShowInvestor',
        params: {
          operationId: this.operationId,
        }
      })
    },
    showTreasury() {
      this.$router.push({
        name: 'TreasuryShow',
        params: {
          operationId: this.operationId,
        }
      })
    },

    clickOnEditBtn() {
      this.$router.push({
        name: 'OperationEdit',
        params: {
          operationId: this.operationId
        }
      })
    },

    clickOnChangeBilanType() {
      this.$bvModal.show('change-bilan-type-operation-modal')
    },

    async didChangeBilanType() {
      await this.fetchData()
      await this.switchOperationLotForVenteLotCreateBilanEXE()
      this.tabs[6] = (this.bilanType && this.bilanType === 'EXE') ? this.$t('operation.show.tab.bilan.exe') : this.$t('operation.show.tab.bilan');
      this.$forceUpdate();
    },

    clickOnDeleteBtn() {
      this.$bvModal.show('item-delete-modal')
    },

    didDeleteOperation() {
      this.$router.push({
        name: 'OperationIndex'
      })
    },

    clickOnFacturesBtn() {
      this.$router.push({
        name: 'OperationFactureIndex',
        params: {
          operationId: this.operationId,
        }
      })
    },

    clickOnDevisBtn() {
      this.$router.push({
        name: 'OperationDevisIndex',
        params: {
          operationId: this.operationId,
        }
      })
    },
  }
}
</script>

<style scoped>
.info-card {
  height: 100%;
}

.general-card {
  height: auto;
}

.finance-card {
  height: 200px;
}

.mini {
  font-size: 11px;
}


.pastille-fail {
  background-color: var(--main-red);
  color: white;
  font-weight: bold;
  padding: 2px 12px;
  border-radius: 15px;
  width: min-content;
}

.avp-btn-inverted {
  background-color: unset !important;
  border: 1px solid var(--exe-color) !important;
  color: var(--exe-color) !important;
  border-radius: var(--main-border-radius) !important;
  font-weight: bold;
}

.avp-btn-inverted:hover {
  background-color: var(--exe-color) !important;
  color: var(--main-white) !important;
}


/* Styles spécifiques pour les boutons AVP */
.exe-btn-inverted {
  background-color: unset !important;
  border: 1px solid var(--avp-color) !important;
  color: var(--avp-color) !important;
  border-radius: var(--main-border-radius) !important;
  font-weight: bold;
}

.exe-btn-inverted:hover {
  background-color: var(--avp-color) !important;
  color: var(--main-white) !important;
}


/* Boutons avec padding switch */
.btn-switch {
  padding: 4px 8px;
}

.custom-disabled{
  opacity: 0.65!important;
  cursor: not-allowed !important;
  pointer-events: none;
}

</style>



// WEBPACK FOOTER //
// src/views/operation/OperationShow.vue